/**
 * Unambiguous display date for international audiences (e.g. SA + US).
 * Example: 10 Jul 2026
 */
const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
] as const;

/** Format a YYYY-MM-DD or ISO date string without UTC day-shift. */
export function formatDisplayDate(value?: string | null): string {
  if (!value) return '';
  const datePart = String(value).split('T')[0];
  const [year, month, day] = datePart.split('-').map(Number);
  if (!year || !month || !day || month < 1 || month > 12) return datePart;
  return `${day} ${MONTHS[month - 1]} ${year}`;
}
